var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{class:`'align-start' + ${_vm.divideX ? 'divide-x broad' : ''}`},[_c('v-col',{attrs:{"md":"12","lg":"2"}},[_c('span',{staticClass:"sidetitle"},[_vm._t("title")],2)]),_vm._v(" "),_c('v-col',{attrs:{"md":"12","lg":"10"}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }